import { UserChatStatus } from '@/components/chat/_domain/modules/user-chat-status-service/user-chat-status-service-interface';
import * as cs from 'checksum';

const chatUserDelimiter = ',';
const chatStatusDelimiter = '|';

function invertChars(input: string): string {
    return input.split('')
                .map((c) => c === c.toUpperCase() ? c.toLowerCase() : c.toUpperCase())
                .join('');
}

class ChatStatusUsers {
    public TeamLeaders: string[] = [];
    public ShiftLeaders: string[] = [];

    constructor(input?: ChatStatusUsers | ChatStatusUserMap | EncodedChatStatusUsers) {
        if (input) {
            this.load(input);
        }
    }

    public load(input: ChatStatusUsers | ChatStatusUserMap | EncodedChatStatusUsers): this {
        if (input instanceof EncodedChatStatusUsers) {
            this.loadFromEncodedChatStatusUsers(input);
        } else if (input instanceof ChatStatusUserMap) {
            this.loadFromChatStatusUserMap(input);
        } else {
            this.TeamLeaders = input.TeamLeaders;
            this.ShiftLeaders = input.ShiftLeaders;
        }
        return this;
    }

    public loadFromChatStatusUserMap(input: ChatStatusUserMap): void {
        this.TeamLeaders = input.get(UserChatStatus.TeamLeader) || [];
        this.ShiftLeaders = input.get(UserChatStatus.ShiftLeader) || [];
    }

    public loadFromEncodedChatStatusUsers(input: EncodedChatStatusUsers): void {
        const imported = new ChatStatusUsers();
        imported.TeamLeaders = this.decode(input.TL);
        imported.ShiftLeaders = this.decode(input.SL);
        this.load(this.isValidChecksum(imported, input.checksum) ? imported : new ChatStatusUsers());
    }

    public makeChecksum(input: ChatStatusUsers = this): string {

        const initialData = [input.TeamLeaders.join(chatUserDelimiter),
                            input.ShiftLeaders.join(chatUserDelimiter)].join(chatStatusDelimiter);
        return cs(initialData);
    }

    public isValidChecksum(input: ChatStatusUsers = this, checksum: string): boolean {
        return this.makeChecksum(input) === checksum;
    }

    private decode(input: string): string[] {
        return atob(invertChars(input)).split(chatUserDelimiter);
    }
}

class EncodedChatStatusUsers {
    public TL: string = '';
    public SL: string = '';
    public checksum: string = '';

    constructor(input?: ChatStatusUsers | ChatStatusUserMap | EncodedChatStatusUsers) {
        if (input) {
            this.load(input);
        }
    }

    public load(input: ChatStatusUsers | ChatStatusUserMap | EncodedChatStatusUsers): this {
        if (input instanceof ChatStatusUsers) {
            this.loadFromChatStatusUsers(input);
        } else if (input instanceof ChatStatusUserMap) {
            this.loadFromChatStatusUserMap(input);
        } else {
            this.TL = input.TL;
            this.SL = input.SL;
        }
        return this;
    }

    public loadFromChatStatusUsers(input: ChatStatusUsers): void {
        this.TL = this.encode(input.TeamLeaders);
        this.SL = this.encode(input.ShiftLeaders);

        this.checksum = input.makeChecksum();
    }

    public loadFromChatStatusUserMap(input: ChatStatusUserMap): void {
        this.loadFromChatStatusUsers(new ChatStatusUsers(input));
    }

    public clear(): this {
        this.TL = '';
        this.SL = '';
        this.checksum = '';
        return this;
    }

    private encode(input: string[]): string {
        return invertChars(btoa(input.join(chatUserDelimiter)));
    }
}

class ChatStatusUserMap extends Map<UserChatStatus, string[]> {
    public loadFromChatStatusUsers(input: ChatStatusUsers): void {
        this.set(UserChatStatus.TeamLeader, input.TeamLeaders);
        this.set(UserChatStatus.ShiftLeader, input.ShiftLeaders);
    }
}
export {ChatStatusUsers, ChatStatusUserMap, EncodedChatStatusUsers};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/store/modules/chat-status-user-map/index.ts